export default __webpack_public_path__ + "static/media/shoesmadd.c80c9752.jpg";